// Polyfills
import 'core-js/stable'

import Vue from 'vue'
import App from './components/App.vue'
import store from './store/store'
import './plugins/vee-validate'
import browserDetect from 'vue-browser-detect-plugin'
import VueScrollTo from 'vue-scrollto'
import VueDateFns from 'vue-date-fns'
import locale from 'date-fns/locale/da'
import VueMask from 'v-mask'
import MonthPicker from '../../../../DM.Umbraco.Frontend/Vue/helpers/MonthPicker'
import VueRouter from 'vue-router'
import DatePickerAirBnb from '../../../../DM.Umbraco.Frontend/Vue/helpers/DatePicker/DatePickerAirBnb'
import LoadingSpinner from '../../../../DM.Umbraco.Frontend/Vue/shared/loading-spinner.vue'
import InputLabel from '../../../../DM.Umbraco.Frontend/Vue/shared/input-label.vue'
import InputMessages from '../../../../DM.Umbraco.Frontend/Vue/shared/input-messages.vue'
import SwitchToggle from '../../../../DM.Umbraco.Frontend/Vue/shared/switch-toggle.vue'
import VueTelInput from 'vue-tel-input';

Vue.use(VueRouter)

Vue.component('DatePickerAirBnb', DatePickerAirBnb)
Vue.component('MonthPicker', MonthPicker)
Vue.component('LoadingSpinner', LoadingSpinner)
Vue.component('InputLabel', InputLabel)
Vue.component('InputMessages', InputMessages)
Vue.component('SwitchToggle', SwitchToggle)

Vue.use(VueDateFns, 'DD MMMM YYYY', {
  locale
})

Vue.use(VueScrollTo)
Vue.use(VueMask)
Vue.use(browserDetect);
Vue.use(VueTelInput);

var router = new VueRouter({
  mode: 'history',
  routes: []
})

Vue.mixin({
  methods: {
    padLeadingZero: function (num, size = 2) {
      let s = num + ''
      // eslint-disable-next-line curly
      while (s.length < size) s = '0' + s
      return s
    }
  }
})

// Vue.config.productionTip = false;

new Vue({
  el: '#amp-signup',
  store,
  router,
  // eslint-disable-next-line space-before-function-paren
  render(h) {
    return h(App, {
      props: {
        // eslint-disable-next-line camelcase
        prop_isTrustee: this.$el.attributes['data-isTrustee']
          ? this.$el.attributes['data-isTrustee'].value
          : '',
        // eslint-disable-next-line camelcase
        prop_isCallCenter: this.$el.attributes['data-isCallCenter']
          ? this.$el.attributes['data-isCallCenter'].value
          : '',
        // eslint-disable-next-line camelcase
        prop_umbracoId: this.$el.attributes['data-umbracoId']
          ? this.$el.attributes['data-umbracoId'].value
          : '',
        prop_studentsUrl: this.$el.attributes['data-studentsUrl']
          ? this.$el.attributes['data-studentsUrl'].value
          : '',
        prop_title: this.$el.attributes['data-title']
          ? this.$el.attributes['data-title']
          : 'Meld dig ind i DM',
        prop_subTitle: this.$el.attributes['data-subTitle']
          ? this.$el.attributes['data-subTitle']
          : 'Din situation',
        prop_campaignCodes: this.$el.attributes['data-campaignCodes']
          ? this.$el.attributes['data-campaignCodes'].value
          : [],
        prop_antiforgeryToken: this.$el.attributes['data-antiforgeryToken']
            ? this.$el.attributes['data-antiforgeryToken'].value
            : '',
        prop_adversusWebhookEnabled: this.$el.attributes['data-adversusWebhookEnabled']
            ? this.$el.attributes['data-adversusWebhookEnabled'].value
            : false,
        prop_pageViewId: this.$el.attributes['data-pageViewId']
            ? this.$el.attributes['data-pageViewId'].value
            : '',
        prop_addressSelectorToken: this.$el.attributes['data-addressSelectorToken']
            ? this.$el.attributes['data-addressSelectorToken'].value
            : ''
      }
    })
  }
})
